import { Component, EventEmitter, Input, OnInit, Output, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Account } from 'src/model/account.model';

@Component({
    selector: 'app-transfer-fund',
    templateUrl: './transfer-fund.component.html',
    styleUrls: ['./transfer-fund.component.scss'],
    standalone: false
})
export class TransferFundComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected sharedService = inject(SharedService);

  @Input() companyBankAccountList: Account[] = [];
  @Input() cashAccountList: Account[] = [];

  selectedAccountId: number;
  selectedTargetAccountId: number;

  @Output() passEntry = new EventEmitter<any>();
  //2-WAY BINDING INFO
  transferDate: Date;
  remark: string;
  amount = 0;
  fee = 0;

  disabledSubmit = false;

  constructor() {
    this.transferDate = new Date();
  }

  ngOnInit(): void {
  }

  setSelectedAccount(accountId: number) {
    if (accountId === this.selectedAccountId)
      return true
    else
      return false;
  }

  setSelectedTargetAccount(accountId: number) {
    if (accountId === this.selectedTargetAccountId)
      return true
    else
      return false;
  }

  isFieldNull() {
    const paymentNull = (this.amount == undefined || this.amount == 0);
    const remarkNull = (this.remark == undefined || this.remark == "");
    const selectedAccountIdNull = (this.selectedAccountId == undefined)
    const selectedTargetAccountIdNull = (this.selectedTargetAccountId == undefined)
    const feeNull = (this.fee == undefined);
    const paymentValid = isNaN(+this.amount);
    const feeValid = isNaN(+this.fee);

    return paymentNull || remarkNull || selectedAccountIdNull || selectedTargetAccountIdNull || feeNull || paymentValid || feeValid
  }

  addTransfer() {
    this.disabledSubmit = true;
    const isoTaskDate = (new Date(Number(this.transferDate))).toISOString();

    const data = {
      "amount": this.amount,
      "accountId": Number(this.selectedTargetAccountId),
      "date": isoTaskDate,
      "remark": this.remark
    };

    const xhr = this.restapi.postRequest(this.constructApi.getPostFundTransfer(this.selectedAccountId), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        this.disabledSubmit = false;
        if (xhr.status == 200) {
          const json = JSON.parse(xhr.responseText);

          const account = new Account(this.selectedAccountId, null, null, null, null, null, null, this.amount)
          this.passEntry.emit(account)
          this.reset();
          this.sharedService.openAlert("Successfully added transfer!", ALERT_TYPE.SUCCESS);
          window.location.reload();

          if (this.fee > 0) {
            this.addTransferFeeExpense();
          }
        }
        else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  addTransferFeeExpense() {
    const isoTaskDate = (new Date(Number(this.transferDate))).toISOString();

    const data = {
      "amount": this.fee,
      "accountId": Number(this.selectedAccountId),
      "date": isoTaskDate,
      "remark": this.remark + "- Transfer Fee"
    };

    const xhr = this.restapi.postRequest(this.constructApi.getAddCompanyExpense(), data);
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const json = JSON.parse(xhr.responseText);

        // let account = new Account(this.selectedAccountId, null, null, null, null, null, null, this.amount)
        // this.passEntry.emit(account)
        // this.reset();
        this.sharedService.openAlert("Successfully added transfer fee expense!", ALERT_TYPE.SUCCESS);
      }
    }
  }

  isFromAccountDisable(balance: number) {
    if (balance != undefined && balance > 0)
      return false
    else
      return true
  }

  isCheckTargetAccountDisable(accountID: number, balance: number) {
    if (this.selectedAccountId != undefined && accountID == this.selectedAccountId)
      return true
    else
      return false
  }

  submit() {
    (this.isFieldNull()) ? this.sharedService.openAlert('Please fill in all the fields', ALERT_TYPE.DANGER) : this.addTransfer();
  }

  reset() {
    this.activeModal.close();
  }
}
